import React from 'react'

import { createSelector } from 'reselect'
import { getProject, getProjectUsers } from './project.selector'
import { getSchedule, getScheduleTaskIds, getScheduleList } from './schedule.selector'
import { filterTasksBySchedule } from '../actions/schedule.actions'
import { dockPadEntityMapToList } from '../containers/DockPadFormTemplates'
import moment from "moment";
import { isFormDisabled } from './user.selector'
import { getTaskFormTemplate, processformStruct } from '../containers/DockPadFormTemplates'
import t from 'tcomb-form'
import bugsnagClient from '../utils/BugSnagClient'
import DatePickerFactory from '../containers/formTemplate/datepickerfactory'
import { dateTransformer } from '../containers/DockPadFormTemplates'


const dockpadformTemplating = require('../containers/formTemplate')

const _ = require("lodash");


export const getEntityId = state => {
    const { editBoardInfo } = state.editboardReducer
    if(!editBoardInfo) {
        return null
    }

    return editBoardInfo.entityId
}


const endTimeFormKey = 'end_time'
const startTimeFormKey = 'start_time'


export const getFormOption = createSelector([isFormDisabled], (disabledForm) => {
    const formOptions = {

        error: <i>WBS Code, Name, and Progress are required!</i>,
        templates: dockpadformTemplating,
        disabled: disabledForm,
        fields: {}
    }

    formOptions['fields']['timeSpan'] = {
        fields: {
            [startTimeFormKey]: {
                label: 'Start Time',
                mode: 'datetime',
                transformer: dateTransformer,
                factory: DatePickerFactory
            },
            [endTimeFormKey]: {
                label: 'End Time',
                mode: 'datetime',
                transformer: dateTransformer,
                factory: DatePickerFactory
            }
        }
    }

    processformStruct(formOptions, getTaskFormTemplate())

    const endStruct =
        formOptions['fields']['timeSpan']['fields'][endTimeFormKey]

    formOptions['fields']['timeSpan']['fields'][endTimeFormKey] = {
        ...endStruct,
        disabled: !!disabledForm
    }

    return formOptions
})

export const getFormStruct = createSelector([getFormOption], (formOption) => {
    const formStruct = t.struct(processformStruct(formOption, getTaskFormTemplate()))

    return formStruct
})



// WEBPACK FOOTER //
// ./src/selectors/task.selector.tsx